import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import tokens from "../../styles/designTokens";
import { body1 } from "../../styles/typography";
import { CenteredProgress } from "../../hocs/configuration";
import { TestingFrameworkConfiguration } from "../../constants";
import { useDispatch } from "react-redux";
import { useExperimentRunner } from "../../hooks/useExperimentRunner";
import { AppDispatch } from "../../store";

const useStyles = makeStyles(() => ({
  buttons: {
    color: 'white',
    textTransform: 'none',
    backgroundColor: tokens.pActive,
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  errorAlert: {
    margin: '15% 0 10% 0',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center'
  },
  input: {
    padding: '0.5rem',
    fontSize: '0.875rem',
    border: '1px solid #ccc',
    borderRadius: '4px'
  },
  body1: {
    ...body1,
    marginTop: '15%',
    color: tokens.core1
  }
}));

const ExperimentControls: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch<AppDispatch>();

  const {
    isRunning,
    runIndex,
    experimentId,
    isCancelled,
    setExperimentId,
    runExperiment,
    cancelExperiment,
  } = useExperimentRunner();

  if (isRunning) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100%">
          <CenteredProgress />
          <Box mt={2} textAlign="center">
            <Typography variant="body1">
              {`Running Experiment: Run ${Math.max(runIndex, 1)} of ${TestingFrameworkConfiguration.runs}`}
            </Typography>
          </Box>
        </Box>
        <Button
          fullWidth
          className={classes.buttons}
          color="secondary"
          variant="outlined"
          disabled={isCancelled}
          onClick={cancelExperiment}
        >
          {isCancelled ? "Cancelling..." : "Cancel"}
        </Button>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" width="100%" gap={1}>
        <input
          type="number"
          placeholder="Experiment ID"
          value={experimentId ?? ""}
          onChange={(e) => dispatch(setExperimentId(Number(e.target.value)))}
          className={classes.input}
          style={{ width: "100%" }}
        />
        <Button
          fullWidth
          className={classes.buttons}
          variant="contained"
          disabled={!experimentId}
          onClick={runExperiment}
        >
          Run Experiment
        </Button>
      </Box>
    </Box>
  );
};

export default ExperimentControls;
